/*
 *
 * BaseHeader
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 19-Nov-2024
 */

import BaseHeader from './BaseHeader'

export default BaseHeader
